import React from "react";
import {observer} from "mobx-react";
import {FormFields} from "../../../../models/forms/form-field.interface";
import {
    IStandardCardFields
} from "../../../../services/booking/models/payment/methods/card/standard-card-fields.interface";
import {IonIcon} from "@ionic/react";
import {StringFieldEditorComponent} from "../../../../components/forms/string-field/string-field-editor.component";
import {calendarOutline, cardOutline, keyOutline, personOutline} from "ionicons/icons";
import styled from "styled-components";
import {
    CardExpirationFieldEditorComponent
} from "../../../../components/forms/card-expiration/card-expiration-field-editor.component";
import {useServices} from "../../../../hooks/use-services.hook";


const CardContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.spacing20};
    width: 100%;
`

const CardFieldsBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: ${props => props.theme.spacing.flexGap20};
    
    ${props => props.theme.containerMediaQuery.smallScreen} {
        flex-direction: column;
    }
`

const CardNumberBox = styled.div`
    flex-basis: 55%;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        flex-basis: unset;
        width: 100%;
    }
`

const CardExpirationBox = styled.div`
    flex-basis: 25%;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        flex-basis: unset;
        width: 100%;
    }
`

const SecurityCodeBox = styled.div`
    flex-basis: 20%;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        flex-basis: unset;
        width: 100%;
    }
`

const FieldIconBox = styled.div`
    display: flex;
    align-items: center;
    font-size: ${props => props.theme.fontSize.h5};
    height: 100%;
    color: ${props => props.theme.colors.dark};
`


interface StandardCardDetailsEditorComponentProps {
    fields: FormFields<IStandardCardFields>;
}
export const StandardCardDetailsEditorComponent: React.FC<StandardCardDetailsEditorComponentProps> = observer((props) => {
    const services = useServices();
    const renderFieldIcon = (iconName: string) => {
        return (
            <FieldIconBox>
                <IonIcon icon={iconName}/>
            </FieldIconBox>
        );
    }

    return (
        <CardContainerBox>
            
            <StringFieldEditorComponent key={props.fields.cardHolder.fieldName}
                                        field={props.fields.cardHolder}
                                        placeholder={services.language.translate('Name on card')}
                                        renderIcon={() => renderFieldIcon(personOutline)}/>

            <CardFieldsBox>
                <CardNumberBox>
                    <StringFieldEditorComponent key={props.fields.cardNumber.fieldName}
                                                field={props.fields.cardNumber}
                                                placeholder={props.fields.cardNumber.fieldName}
                                                renderIcon={() => renderFieldIcon(cardOutline)}/>
                </CardNumberBox>


                <CardExpirationBox>
                    <CardExpirationFieldEditorComponent field={props.fields.expirationDate} renderIcon={() => renderFieldIcon(calendarOutline)}/>
                </CardExpirationBox>

                <SecurityCodeBox>
                    <StringFieldEditorComponent key={props.fields.cvv.fieldName}
                                                field={props.fields.cvv}
                                                inputMode={"numeric"}
                                                placeholder={"CVV"}
                                                renderIcon={() => renderFieldIcon(keyOutline)}/>
                </SecurityCodeBox>



            </CardFieldsBox>



        </CardContainerBox>
    )
})
